import * as Config from '../../../../../config';
import React from "react";
import { useSelector /*, useDispatch*/ } from 'react-redux';
// import { MenuItem } from "react-contextmenu";
import { Content, Item, Portal } from "@radix-ui/react-context-menu";

// import { setContextMenu } from "../../../../../actions/index";
import { getContextMenuPortalContainer, rightClickContextMenu } from "../../../../../utils/zoomMenu";

import IconPlayLeft from '../svg/IconPlayLeft';
import IconPlayRight from '../svg/IconPlayRight';
import IconPlus from '../svg/IconPlus';
import IconRedirect from '../svg/IconRedirect';
import IconRemove from '../svg/IconRemove';
import IconCart from '../svg/IconCart';
import IconAddedCart from '../svg/IconAddedCart';

// TODO - REWORK
const useRowAction = (
  itemID,
  playerLoadSong, addToPlaylist, toStore, 
  removeItem = null, isRestricted = false, loadToAutomix = null,
  addToCart = null, isTombstoned = null
) => {
  // const dispatch = useDispatch();
  const cartItems = useSelector( state => state.cartItems );
  const isInCart = cartItems.some( id => id === itemID);
  
  /* 
  // V1 - react-contextmenu
  const setActionsContextMenu = () => {
    const content = [];
    // <MenuItem key={`previewItem`} onClick={previewPlayer.play(idParent, index)} data={{ action: 'Preview' }}>{`Preview Track`}</MenuItem>,
    // <div className={`separator`} />,
    if (!isRestricted && loadToAutomix === null && !isTombstoned) {
      content.push(
        <MenuItem key={`playDeck1Item`} onClick={playerLoadSong(1)} data={{ action: 'Play Deck A' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconPlayLeft color={Config.BRAND_PRIMARY} />
            {`Load Deck A`}
          </div>
        </MenuItem>
      );
      content.push(
        <MenuItem key={`playDeck2Item`} onClick={playerLoadSong(2)} data={{ action: 'Play Deck B' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconPlayRight color={Config.BRAND_TERTIARY} />
            {`Load Deck B`}
          </div>
        </MenuItem>
      )
    }
    if (loadToAutomix && !isTombstoned) {
      content.push(
        <MenuItem key={`loadAutomix`} onClick={loadToAutomix} data={{ action: 'Load track to automix' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconPlayRight color={Config.BRAND_PRIMARY} />
            {`Skip to track`}
          </div>
        </MenuItem>
      )
    }
    if (addToCart && !isTombstoned) {
      content.push(
        <MenuItem key={`addToCart`} onClick={addToCart} data={{ action: 'Add' }}>
          <div className={'flexRow block-contextmenu-item'}>
            { isInCart ? <IconAddedCart color={'#8C8C8C'} size={16} /> : <IconCart color={'#8C8C8C'} size={16} /> }
            { isInCart ? `Added to cart` : `Add to cart`}
          </div>
        </MenuItem>
      );
    }
    if (!isTombstoned) {
      content.push(
        <MenuItem key={`addToPlaylist`} onClick={addToPlaylist} data={{ action: 'Add' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconPlus color={'#8C8C8C'} />
            {`Add to playlist`}
          </div>
        </MenuItem>
      );
    }
    if (removeItem) {
      content.push(
        <MenuItem key={`rPlaylist`} onClick={removeItem} data={{ action: 'Remove' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconRemove />
            {`Remove track`}
          </div>
        </MenuItem>
      )
    }
    if (!isTombstoned) {
      content.push(
        <MenuItem key={`toStore`} onClick={toStore} data={{ action: 'To' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconRedirect />
            {`View on ${Config.capAppName()}`}
          </div>
        </MenuItem>
      )
    }
    dispatch(setContextMenu(content, {className: 'dynamic-menu-row-menu'}));
  }
  */

  const showContextMenu = (e) => {
    // setActionsContextMenu();  // V1 - react-contextmenu
    rightClickContextMenu(e); // V2 - Right Click Simulation
  }

  // DEPRECATED
  // const showExtraMenu = (viewOn = false) => {
  //   const content = [];
  //   content.push(
  //     <MenuItem key={`addToPlaylist`} onClick={addToPlaylist} data={{ action: 'Add' }}>
  //       <div className={'flexRow block-contextmenu-item'}>
  //         <IconPlus />
  //         {`Add to playlist`}
  //       </div>
  //     </MenuItem>
  //   );
  //   if (addToCart) {
  //     content.push(
  //       <MenuItem key={`addToCart`} onClick={addToCart} data={{ action: 'Add' }}>
  //         <div className={'flexRow block-contextmenu-item'}>
  //           { isInCart ? <IconAddedCart color={'#EF476F'} size={16} /> : <IconCart color={'#EF476F'} size={16} /> }
  //           { isInCart ? `Added to cart` : `Add to cart`}
  //         </div>
  //       </MenuItem>
  //     );
  //   }
  //   if (viewOn) {
  //     content.push(
  //       <MenuItem key={`toStore`} onClick={toStore} data={{ action: 'To' }}>
  //         <div className={'flexRow block-contextmenu-item all-hover'}>
  //           <IconRedirect />
  //           {`View on ${Config.capAppName()}`}
  //         </div>
  //       </MenuItem>
  //     )
  //   }
  //   dispatch(setContextMenu(content, {className: 'dynamic-menu-row-menu'}));
  // }

  //V2 - @radix-ui/react-context-menu
  const ContextMenuContent = () => (
    <Portal container={getContextMenuPortalContainer()}>
      <Content
        className={'dynamic-menu-v2'}
        style={(window.window_zoom || 1) !== 1
          ? { transform: `scale(${window.window_zoom})`, transformOrigin: 'top left' }
          : undefined}
      >
        { (!isRestricted && loadToAutomix === null && !isTombstoned) && (
          <>
            <Item onSelect={playerLoadSong(1)}>
              <div className={'flexRow block-contextmenu-item-v2'}>
                <IconPlayLeft color={Config.BRAND_PRIMARY} />
                {`Load Deck A`}
              </div>
            </Item>
            <Item onSelect={playerLoadSong(2)}>
              <div className={'flexRow block-contextmenu-item-v2'}>
                <IconPlayRight color={Config.BRAND_TERTIARY} />
                {`Load Deck B`}
              </div>
            </Item>
          </>
        )}
        { (loadToAutomix && !isTombstoned) && (
          <Item onSelect={loadToAutomix}>
            <div className={'flexRow block-contextmenu-item-v2'}>
              <IconPlayRight color={Config.BRAND_PRIMARY} />
            {`Skip to track`}
            </div>
          </Item>
        )}
        { (addToCart && !isTombstoned) && (
          <Item onSelect={addToCart}>
            <div className={'flexRow block-contextmenu-item-v2'}>
              { isInCart ? <IconAddedCart color={'#8C8C8C'} size={16} /> : <IconCart color={'#8C8C8C'} size={16} /> }
              { isInCart ? `Added to cart` : `Add to cart`}
            </div>
          </Item>
        )}
        { (!isTombstoned) && (
          <Item onSelect={addToPlaylist}>
            <div className={'flexRow block-contextmenu-item-v2 all-hover'}>
              <IconPlus color={'#8C8C8C'} />
              {`Add to playlist`}
            </div>
          </Item>
        )}
        { (removeItem) && (
          <Item onSelect={removeItem}>
            <div className={'flexRow block-contextmenu-item-v2'}>
              <IconRemove />
              {`Remove track`}
            </div>
          </Item>
        )}
        { (!isTombstoned) && (
          <Item onSelect={toStore}>
            <div className={'flexRow block-contextmenu-item-v2 all-hover'}>
              <IconRedirect />
              {`View on ${Config.capAppName()}`}
            </div>
          </Item>
        )}
      </Content>
    </Portal>
  )

  const storeX = {
    showContextMenu,
    // showExtraMenu,
    ContextMenuContent
  };

  return storeX;
};

export default useRowAction;
